import React from 'react'
import { globalMenuItemData } from '../../models/axiosModel';
import { Divider, Menu, MenuProps, PopoverOrigin, PopoverProps } from '@mui/material';
import globalStyles from "../../assets/styles/global.module.scss";
import GlobalMenuGroup from './globalMenuGroup';
import GlobalMenuItem from './globalMenuItem';
import clsx from 'clsx';

interface GlobalMenuProps {
    menuItemData: globalMenuItemData[],
    anchorEl: PopoverProps['anchorEl'],
    handleMenuClose: () => void,
    open: boolean,
    additionalField?: any, // To hold the value of object which could pass to the onClick function.
    transformOrigin?: PopoverOrigin;
    anchorOrigin?: PopoverOrigin;
    className?: string;
    classes?: MenuProps['classes'];
    disablePortal?: boolean;
    MenuListProps?: MenuProps['MenuListProps'];
} 

const GlobalMenu: React.FC<GlobalMenuProps> = (props) => {
    
    const {
        menuItemData,
        anchorEl,
        handleMenuClose,
        open,
        additionalField,
        transformOrigin,
        anchorOrigin,
        className,
        classes,
        disablePortal,
        MenuListProps,
    } = props;

    const renderMenuItem = (menuItem: globalMenuItemData, index: number, handleMenuClose: () => void) => {
        switch(menuItem?.type){
            case "item": 
                return <GlobalMenuItem menuItem={menuItem} index={index} handleMenuClose={handleMenuClose} additionalField={additionalField} />;
            case "group":
                return <GlobalMenuGroup menuItem={menuItem} index={index} handleMenuClose={handleMenuClose} renderMenuItem={renderMenuItem} />;
            case "divider":
                return <Divider className={`${globalStyles.fullwidth} ${globalStyles.greyColor}`} />;
            default: 
                return <></>;
        }
    }

    return (
        <>
            {menuItemData?.length > 0 && (
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl) && open}
                    onClose={(e: React.SyntheticEvent) => { e.stopPropagation(); handleMenuClose(); }}
                    transformOrigin={transformOrigin}
                    anchorOrigin={anchorOrigin}
                    className={clsx(globalStyles.globalMenu, className ?? "")}
                    classes={classes}
                    disablePortal={disablePortal}
                    MenuListProps={MenuListProps}
                >
                    {menuItemData?.map((menuItem, index) => {
                        return renderMenuItem(menuItem, index, handleMenuClose);
                    })}
                </Menu>
            )}
        </>
    )
}

export default GlobalMenu
